import React from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import Home from "./home";
import Gallery from "./gallery";
import AddGalleryImage from "./add-gallery";
import EditGalleryImage from "./editGalleryImage";
import Activities from "./activity";
import EditActivities from "./editActivity";
import AddActivities from "./addActivity";
import Mpd from "./mpd";
import AddMpd from "./addMpd";
import EditMpd from "./editMpd";
import GeneralInfo from "./generalinfo";
import Staff from "./staff";
import Infrastructure from "./infrastructure";
import Academics from "./academics";

const Dashboard = () => {
  return (
    <>
      <Layout>
        <div className="row gy-4 mb-24"></div>
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/add-gallery" element={<AddGalleryImage />} />
          <Route path="/edit-gallery/:id" element={<EditGalleryImage />} />
          <Route path="/activity" element={<Activities />} />
          <Route path="/edit-activity/:id" element={<EditActivities />} />
          <Route path="/add-activity" element={<AddActivities />} />
           <Route path="/mpd" element={<Mpd />} />
                <Route path="/add-mpd" element={<AddMpd />} />
                     <Route path="/edit-mpd/:id" element={<EditMpd />} />
                          <Route path="/general-info" element={<GeneralInfo />} />
                           <Route path="/staff" element={<Staff />} />
                           <Route path="/infrastructure" element={<Infrastructure />} />
                           <Route path="/academics" element={<Academics />} />
        </Routes>
      </Layout>
    </>
  );
};

export default Dashboard;
